import React, { useEffect, useState } from "react";
import { padalaServices } from "../services/PadalaServices";
import { adminServices } from "../services/AdminServices";
import { dltService } from "../services/DltService";
import DataTable, { Alignment } from "react-data-table-component";
import { ReactComponent as TransactionIcon } from "../icons/receipt.svg";
import LoadingModal from "../components/LoadingModal";
import Button from '../components/Button';
import SearchBar from "../components/SearchBar";
import { formatCurrency } from "../tools/tool";
import InputText1 from "../components/InputText1";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import {v4 as uuidv4} from 'uuid';
import Modal from "react-modal";
import AlertModal from "../components/AlertModal";
import ImageModal from "../components/ImageModal";
import withAuthorization from "../components/withAuthorization";
import { jwtDecode } from "jwt-decode";
import ConfirmationDialog from "../components/ConfirmationDialog";
import { logExport } from "../services/ExportLogService";

const CashOutRequests = () => {
  const [kioskSales, setKioskSales] = useState(null);
  const [data, setData] = useState([]);
  // const [columns, setColumns] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [historyData,setHistoryData] = useState([]);

  const [IsAdmin, setIsAdmin] = useState(false);
  
  const [showHistory, setShowHistory] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  // image modal state (image-only modal opened from Reference cell)
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageModalReference, setImageModalReference] = useState(null);
  const [imageModalExtraText, setImageModalExtraText] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [cashOutStatus, setCashOutStatus] = useState('');
  const [pendingData, setPendingData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [adminName, setAdminName] = useState("");
  const [referenceNo, setReferenceNo] = useState('');

  const [selected, setSelected] = useState("pending");

  // Confirmation Dialog
  const [showConfirm, setShowConfirm] = useState(false);

  const customStyles = { 
    overlay: { 
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
    }, 
    content: {
        width: '90%', margin: 'auto', 
        height : '100%',
        backgroundColor:'transparent',
        border: 0
    },
  };

let columns = [
    { name: 'Transaction Date', selector: row=>new Date(row.timestamp).toLocaleString(), sortable: true, grow: 1, minWidth: '140px' },
    { name: 'Reference No', sortable: true, grow: 0, minWidth: '100px', cell: row => (
        <button
          className="btn btn-link p-0 small"
          style={{ fontSize: '0.85rem', lineHeight: 1 }}
          onClick={(e)=>{ e.stopPropagation(); setImageModalReference(row.ref_no); setImageModalExtraText(row.remarks || ''); setShowImageModal(true); }}
        >
          {row.ref_no}
        </button>
      ) },
    { name: 'Amount', selector: row=>formatCurrency(Math.abs(row.amount)), sortable: true, grow: 0, minWidth: '100px', right: true },
    { name: 'PDL Number', selector: row=>row.pdl_number, sortable: true, grow: 1, minWidth: '120px' },
    { name: 'PDL Name', selector: row=>row.pdlName, sortable: true, grow: 2, minWidth: '150px', cell: row => <div style={{whiteSpace:'normal', wordBreak:'break-word'}}>{row.pdlName}</div> },
    { name: 'Status', selector: row=>row.current_status, sortable: true, grow: 0, minWidth: '100px' },
    { name: 'Remarks', selector: row=>row.remarks, sortable: true, grow: 3, minWidth: '180px', cell: row => (
        <div style={{whiteSpace:'normal', wordBreak:'break-word'}} title={row.remarks || ''}>
          {row.remarks ? (row.remarks.length > 80 ? (row.remarks.slice(0,80) + '...') : row.remarks) : ''}
        </div>
      ) },
  ]

  // Table styles to avoid horizontal scrolling: fixed layout + wrapping cells
  const mainTableStyles = {
    table: {
      style: {
        tableLayout: 'fixed'
      }
    },
    cells: {
      style: {
        whiteSpace: 'normal',
        wordBreak: 'break-word'
      }
    }
  };

  useEffect(()=>{
    setLoading(true);
    CORequests();

    var token = localStorage.getItem("appToken");
    setIsAdmin(jwtDecode(token)["isAdmin"] === "1");
    setAdminName(jwtDecode(token)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]);

  },[]);

  const exportToCSV = async (data) => {
  if (!data || data.length === 0) return;

  // Log the export
  await logExport('Cash Out Requests');

  const headers = [
    'Transaction Date',
    'Reference No',
    'Amount',
    'PDL Number',
    'PDL Name',
    'Status',
    'Remarks'
  ];

  const rows = data.map(row => [
    new Date(row.timestamp).toLocaleString(),
    row.ref_no,
    Math.abs(row.amount), // raw numeric value
    row.pdl_number,
    row.pdlName,
    row.current_status,
    row.remarks
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'CashOutRequests.csv');
  link.click();
};


  const CORequests = ()=>{
    var form = new FormData();
    form.append('params','');
    
    Promise.all([
      adminServices.storeProcedure2('cash_out_request', {}),
      adminServices.storeProcedure2('get_canceled_cashout_transactions', {})
    ]).then(([requestResponse, canceledResponse]) => {
      let allData = [];
      
      if (requestResponse.data && requestResponse.data.length > 0) {
        allData = [...requestResponse.data];
      }
      
      if (canceledResponse.data && canceledResponse.data.length > 0) {
        const normalizedCanceledData = canceledResponse.data.map(item => ({
          timestamp: item.timestamp,
          ref_no: item.ref_no,
          amount: item.amount,
          client_id: item.client_id || '',
          pdl_number: item.pdl_number || item.client_id || '',
          pdlName: item.pdlName || item.pdl_name || '',
          current_status: 'Canceled',
          remarks: item.remarks || ''
        }));
        
        // Remove duplicates based on ref_no and timestamp
        const existingRefNos = new Set(allData.map(item => item.ref_no));
        const uniqueCanceledData = normalizedCanceledData.filter(item => 
          !existingRefNos.has(item.ref_no)
        );
        
        allData = [...allData, ...uniqueCanceledData];
      }

      // Remove any remaining duplicates based on ref_no + timestamp combination
      const uniqueData = allData.filter((item, index, self) => 
        index === self.findIndex(t => t.ref_no === item.ref_no && t.timestamp === item.timestamp)
      );

      setKioskSales(uniqueData);
      setData(uniqueData);

      let completed = uniqueData.filter(item => item.current_status === "Completed");
      let pending = uniqueData.filter(item => item.current_status != "Completed" && item.current_status != "Canceled");
      let canceled = uniqueData.filter(item => item.current_status === "Canceled");

      setPendingData([...pending, ...canceled]);
      setCompletedData(completed);

      setFilteredData([...pending, ...canceled]);

      let gT = [...pending, ...canceled].reduce((total, item) => total + Math.abs(item.amount), 0)
      setGrandTotal( gT ) ;

      setLoading(false);

    }).catch ((error)=>{
      if(error.status === 401){
        window.location.href = "/";
      }
      setLoading(false);
    })

  }

  const CORequestRange = async ()=>{

    let params = {
      dateFrom: dateFrom,
      dateTo: dateTo
    }
    
    Promise.all([
      adminServices.storeProcedure2('cash_out_requests_range', params),
      adminServices.storeProcedure2('get_canceled_cashout_requests_range', params)
    ]).then(([requestResponse, canceledResponse]) => {
      let allData = [];
      
      if (requestResponse.data && requestResponse.data.length > 0) {
        allData = [...requestResponse.data];
      }
      
      if (canceledResponse.data && canceledResponse.data.length > 0) {
        const filteredCanceled = canceledResponse.data.filter(item => {
          const itemDate = new Date(item.timestamp).toISOString().split('T')[0];
          return itemDate >= dateFrom && itemDate <= dateTo;
        });
        
        const normalizedCanceledData = filteredCanceled.map(item => ({
          timestamp: item.timestamp,
          ref_no: item.ref_no,
          amount: item.amount,
          client_id: item.client_id || '',
          pdl_number: item.pdl_number || item.client_id || '',
          pdlName: item.pdlName || item.pdl_name || 'Canceled Transaction',
          current_status: 'Canceled',
          remarks: item.remarks || 'Canceled by Admin'
        }));
        
        // Remove duplicates based on ref_no
        const existingRefNos = new Set(allData.map(item => item.ref_no));
        const uniqueCanceledData = normalizedCanceledData.filter(item => 
          !existingRefNos.has(item.ref_no)
        );
        
        allData = [...allData, ...uniqueCanceledData];
      }

      // Remove any remaining duplicates based on ref_no + timestamp combination
      const uniqueData = allData.filter((item, index, self) => 
        index === self.findIndex(t => t.ref_no === item.ref_no && t.timestamp === item.timestamp)
      );

      let completed = uniqueData.filter(item => item.current_status === "Completed");
      let pending = uniqueData.filter(item => item.current_status != "Completed" && item.current_status != "Canceled");
      let canceled = uniqueData.filter(item => item.current_status === "Canceled");

      setPendingData([...pending, ...canceled]);
      setCompletedData(completed);

      setKioskSales([...pending, ...canceled]);
      setData([...pending, ...canceled]);
      setFilteredData([...pending, ...canceled]);

      let gT = [...pending, ...canceled].reduce((total, item) => total + Math.abs(item.amount), 0)
      setGrandTotal( gT ) ;

      setLoading(false);

    }).catch ((error)=>{
      if(error.status === 401){
        window.location.href = "/";
      }
      setLoading(false);
    })

  }

  const COHistory = async (row)=>{
    setLoading(true);
    var form = new FormData();
    setReferenceNo(row.ref_no);
    form.append('params',`'${row.ref_no}'`);

    let params = {
      refNo : row.ref_no
    }

    await adminServices.storeProcedure2('cash_out_request_history', params).then((r)=>{
      

      if(r.data.length > 0){
        setHistoryData(r.data);
        setCashOutStatus(r.data[r.data.length-1].description);
        return;
      }
      setHistoryData([]);
      let co = row.current_status === "Completed" ? "Completed" : (row.current_status === "Canceled" ? "Canceled" : "Pending");
      setCashOutStatus(co);

    }).catch ((error)=>{
      if(error.status === 401){
        window.location.href = "/";
      }
    }).finally(()=>{
      setLoading(false);
    })

  }

  const handleClose = ()=>{  
    
    setShowAlert(false);

    if(isSuccess){ 
      window.location.href = "/cashout-requests";
    }
  }

  const handleRowClicked = async (row) => {
      await COHistory(row);
      setSelectedRow(row);
      setShowHistory(true);
  };

  

  return (
    <div className="container">
      <ConfirmationDialog show={showConfirm} title={"Cancel Cash Out Request"} message={
        "Are you sure you want to cancel this cash out request?"
      } onCancel={()=>{
        setShowConfirm(false);
      }} onConfirm={ async ()=>{
        setLoading(true);

        if (selectedRow && selectedRow.client_id && selectedRow.amount) {
          dltService.applyCreditingAsync(
            selectedRow.client_id,
            Math.abs(selectedRow.amount),
            referenceNo
          ).then(async () => {
            setShowAlert(true);
            setAlertMessage("Cash Out Request has been cancelled successfully.");
            setIsSuccess(true);
            setLoading(false);
          }).catch(() => {
            setShowAlert(true);
            setAlertMessage("Failed to cancel Cash Out Request. Please try again.");
            setIsSuccess(false);
            setLoading(false);
          });
        }

      }} />
      <AlertModal show={showAlert} title="Cash Out Requests" message={alertMessage} onClose={handleClose} />
      <LoadingModal show={loading} message={"Loading..."}/>
      <Modal 
        isOpen={showHistory}
        style={customStyles}
        onRequestClose={()=>setShowHistory(false)}
      >
        <div className="card">
          <div className="card-header">Cash Out Request {selectedRow && selectedRow.pdlName}</div>
          <div className="card-body">
            <div className="row">
                <div className="col-md-6 fw-bold">Requested Date</div>
                <div className="col-md-6">{selectedRow && new Date(selectedRow.timestamp).toLocaleString()}</div>
            </div>
            <div className="row">
                <div className="col-md-6 fw-bold">Reference No</div>
                <div className="col-md-6">{selectedRow && selectedRow.ref_no}</div>
            </div>
            <div className="row">
                <div className="col-md-6 fw-bold">Current Status</div>
                <div className="col-md-6">{selectedRow && historyData.length == 0 ? "Pending" : cashOutStatus}</div>
            </div>
            <div className="row">
                <div><hr/></div>
            </div>
            <div className="row">
                <DataTable
                    columns={[
                      {name: 'Transaction Date', selector: row=>new Date(row.timestamp).toLocaleString(), sortable: true,width:'200px' },
                      {name: 'Description', selector: row=>row.description, sortable: true,width:'150px' },
                      {name: 'Remarks', selector: row=>row.remarks, sortable: true }
                    ]}
                    striped
                    pointerOnHover
                    data={historyData}
                 />
            </div>
          </div>
          <div className="card-footer d-flex justify-content-end">
            <div className="btn-group">
              {IsAdmin && cashOutStatus &&  cashOutStatus == "Pending" &&  <Button variant={"danger"} size={"sm"} onClick={()=>
                {
                  setShowConfirm(true);
                }
              }>
                Cancel Cash Out Request
              </Button>}
              <Button variant={"primary"} size={"sm"} onClick={()=>setShowHistory(false)}>Close</Button>
            </div>
            
          </div>
        </div>
      </Modal>
      <div style={{fontSize:'1.5rem', fontWeight:'bold', marginBottom:10, display: 'flex', justifyContent:'space-between',alignItems:'center'}}>
        <div className="d-flex align-items-center">
          <TransactionIcon style={{ width: "50px", height: "50px", marginRight: "10px",background:'transparent' }} />
         PDL Cash Out Requests ({formatCurrency(Math.abs(grandTotal))})
        </div>

         <div className="d-flex justify-content-end">
            {/* <Button variant={"primary"} size={"lg"} onClick={handleTransfer}> Cash Out Request </Button> */}
          </div>
      </div>

      <div className="flexRow" style={{width:'50%'}}>
          <InputText1 title={"Date From"} type="date" value={dateFrom} onChange={(e)=>{
            setDateFrom(e.target.value);
          }}  />

         <InputText1 title={"Date To"} type="date" value={dateTo} onChange={async(e)=>{
            setDateTo(e.target.value);
          }}  />

          <div style={{marginTop:18}}>
            <Button variant={"primary"} onClick={CORequestRange}>Search</Button>
          </div>

      </div>

      <div className="flexRow">
        <div className="flexRow filterDiv">
          <SearchBar
            placeholder="Search Cash Out Requests"
            onChange={(e)=>{
              const value = e.target.value.toLowerCase();
              const filtered = data.filter(item => 
                Object.keys(item).some(key => 
                  item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase()) 
                ) 
              );
              setFilteredData(filtered);

              let gT = filtered.reduce((total, item) => total + item.amount, 0)
              setGrandTotal( gT ) ;
            }}
          />
        </div>
        &nbsp;&nbsp;
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
        </div>
        <div className="spacer"></div>
        <div>
          <Button variant={selected == "pending" ? "primary" : "secondary"} size={'xs'} onClick={()=>{

            const pendingOnly = pendingData.filter(item => item.current_status != "Canceled");
            setFilteredData(pendingOnly);
            setData(pendingOnly);
            let gT = pendingOnly.reduce((total, item) => total + Math.abs(item.amount), 0)
            setGrandTotal( gT ) ;

            setSelected("pending");

          }}> Pending / Cash Out Approved </Button>&nbsp;
          <Button variant={selected == "canceled" ? "primary" : "secondary"} size={'xs'} onClick={()=>{

            const canceledOnly = pendingData.filter(item => item.current_status === "Canceled");
            setFilteredData(canceledOnly);
            setData(canceledOnly);
            let gT = canceledOnly.reduce((total, item) => total + Math.abs(item.amount), 0)
            setGrandTotal( gT ) ;

            setSelected("canceled");

          }}> Canceled </Button>&nbsp;
          <Button variant={selected == "completed" ? "primary" : "secondary"} size={'xs'} onClick={()=>{

            setFilteredData(completedData);
            setData(completedData);
            let gT = completedData.reduce((total, item) => total + Math.abs(item.amount), 0)
            setGrandTotal( gT ) ;

            setSelected("completed");

          }}> Completed </Button>&nbsp;
          <Button variant={"success"} size={'xs'} onClick={()=>exportToCSV(filteredData)}> Export to CSV </Button>
        </div>
      </div>
        <br/>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination={false}
          persistTableHead
          highlightOnHover
          onRowClicked={handleRowClicked}
          customStyles={mainTableStyles}
        />
        {/* Image-only modal opened when clicking Reference No */}
        <ImageModal
          show={showImageModal}
          referenceNo={imageModalReference}
          extraText={imageModalExtraText}
          title={"Attachment"}
          onClose={() => setShowImageModal(false)}
        />
    </div>
  );
};

export default withAuthorization(CashOutRequests,24);
